export enum DirectCommunicationType {
  CustomMessage = 1,
  PatientNotification = 4,
  PostReviewToGoogle = 12,
}

export interface EmailTemplateDataModel {
  Subject: string;
  FromName: string;
  InternalTemplateData: any; // returned by the template editor iframe
}